import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card } from '@/components/ui/card';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AdminLogin = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/admin/login`, {
        username,
        password
      });

      if (response.data.message === 'Login successful') {
        localStorage.setItem('admin_token', response.data.token);
        if (response.data.must_change_password) {
          localStorage.setItem('admin_must_change_password', '1');
          toast.success(t('common.success'));
          navigate('/admin/dashboard?forceChange=1');
          return;
        }
        localStorage.removeItem('admin_must_change_password');
        toast.success(t('common.success'));
        navigate('/admin/dashboard');
      }
    } catch (error) {
      console.error('Login error:', error);
      toast.error(t('common.error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF7] flex items-center justify-center px-4">
      <Card className="max-w-md w-full p-10 border border-[#E3E5DF]/40 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
        <h1 
          className="text-4xl font-light text-[#2C302E] mb-8 text-center tracking-tight"
          style={{fontFamily: 'Cormorant Garamond, serif'}}
          data-testid="admin-login-title"
        >
          {t('admin.login')}
        </h1>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <Label htmlFor="username">{t('admin.username')}</Label>
            <Input
              id="username"
              name="username"
              type="text"
              placeholder="admin"
              data-testid="admin-username-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="mt-1"
              required
            />
          </div>

          <div>
            <Label htmlFor="password">{t('admin.password')}</Label>
            <Input
              id="password"
              name="password"
              type="password"
              placeholder="••••••••"
              data-testid="admin-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1"
              required
            />
          </div>

          <Button
            type="submit"
            data-testid="admin-login-button"
            disabled={loading}
            className="w-full bg-[#8A9A86] hover:bg-[#7A8A76] text-white rounded-full py-6"
          >
            {loading ? t('common.loading') : t('admin.loginButton')}
          </Button>
        </form>
      </Card>
    </div>
  );
};
